'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { SimpleGrid } from '@s7/layout';
import { chunks } from '@s7/utils';
import { useFooterNavigationContext } from '../FooterNavigation.context.js';
import { NavigationCategory } from './NavigationCategory/NavigationCategory.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Разбивает категории с количеством элементов большим, чем ограничение,
 * на категории для которых ограничение удовлетворяется.
 * */ function splitLimit(categories, limit) {
    return categories.map((category)=>{
        if (category.items && category.items.length > limit) {
            return chunks(category.items, limit).map((items, index)=>_extends({}, category, {
                    id: `${category.id}-${index}`,
                    items
                }, index !== 0 && {
                    title: false
                }));
        }
        return category;
    }).flat();
}
const FooterNavigationDesktop = ({ categories })=>{
    const { maxColItems } = useFooterNavigationContext();
    return /*#__PURE__*/ jsx(SimpleGrid, {
        cols: 4,
        spacing: 24,
        children: splitLimit(categories, maxColItems).map((category)=>/*#__PURE__*/ jsx(NavigationCategory, _extends({}, category), category.id))
    });
};

export { FooterNavigationDesktop };
//# sourceMappingURL=FooterNavigationDesktop.js.map
